import React, { useState } from 'react';
import apiClient from '../api/apiClient';

export default function FilesPage({ location, files, onBack, loading, onFilesChanged }) {
  const [busyId, setBusyId] = useState(null);

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
  };
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('es-MX', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const handleDownload = async (file) => {
    setBusyId(file.id);
    const result = await apiClient.downloadFile(location.id, file.id, file.original_name);
    setBusyId(null);
    if (!result.success) {
      alert('Error al descargar: ' + (result.error || ''));
    }
  };

  const handleRemove = async (file) => {
    const ok = window.confirm('¿Eliminar el archivo "' + file.original_name + '"?\nEsta acción no se puede deshacer.');
    if (!ok) return;
    setBusyId(file.id);
    const result = await apiClient.deleteFile(location.id, file.id);
    setBusyId(null);
    if (result.success) {
      if (onFilesChanged) onFilesChanged();
    } else {
      alert('Error al eliminar: ' + (result.error || ''));
    }
  };

  return (
    <div>
      <button onClick={onBack} className="btn-back">← Volver</button>
      <h2 style={{color:'#1e3c72',marginBottom:'2rem'}}>📁 {location?.name}</h2>
      {files.length === 0 ? (
        <p>No hay archivos</p>
      ) : (
        <table className="files-table">
          <thead>
            <tr>
              <th>📄 Nombre</th>
              <th>📊 Tamaño</th>
              <th>📅 Fecha</th>
              <th>⚙️ Acción</th>
            </tr>
          </thead>
          <tbody>
            {files.map((file) => (
              <tr key={file.id}>
                <td>{file.original_name}</td>
                <td>{formatFileSize(file.file_size)}</td>
                <td>{formatDate(file.created_at)}</td>
                <td>
                  <div style={{display:'flex',gap:'0.5rem'}}>
                    <button
                      className="btn-download"
                      disabled={loading || busyId === file.id}
                      onClick={() => handleDownload(file)}
                    >
                      {busyId === file.id ? '...' : '📥 Descargar'}
                    </button>
                    <button
                      disabled={loading || busyId === file.id}
                      onClick={() => handleRemove(file)}
                      style={{background:'#dc3545',color:'white',padding:'0.5rem 1rem',border:'none',borderRadius:'4px',cursor:'pointer'}}
                    >
                      🗑️ Remover
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
